import { render, staticRenderFns } from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=template&id=1584f280&"
import script from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports